const OrangePhone = ({ ...props }) => {
  return (
    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25 0.5C1.01627 0.5 0 1.51627 0 2.75V19.25C0 20.4837 1.01627 21.5 2.25 21.5H9.75C10.9837 21.5 12 20.4837 12 19.25V2.75C12 1.51627 10.9837 0.5 9.75 0.5H2.25ZM2.25 2H3C3 2.82875 3.67125 3.5 4.5 3.5H7.5C8.32875 3.5 9 2.82875 9 2H9.75C10.1738 2 10.5 2.32623 10.5 2.75V19.25C10.5 19.6738 10.1738 20 9.75 20H2.25C1.82623 20 1.5 19.6738 1.5 19.25V2.75C1.5 2.32623 1.82623 2 2.25 2ZM6 17.75C5.58675 17.75 5.25 18.0868 5.25 18.5C5.25 18.9132 5.58675 19.25 6 19.25C6.41325 19.25 6.75 18.9132 6.75 18.5C6.75 18.0868 6.41325 17.75 6 17.75Z" fill="#EB5B25"/>
    </svg>
  )
}

export default OrangePhone